package it.neckar.lizergy.model.configuration.quote.builder

import it.neckar.open.unit.si.m
import it.neckar.uuid.HasUuid
import it.neckar.uuid.NativeUuid
import it.neckar.uuid.randomUuid4
import kotlinx.serialization.Serializable
import kotlin.uuid.Uuid

interface WallboxSelection : HasUuid {
   val id: WallboxSelectionId
  val throttled: Boolean
  val kabelweg: @m Double

   override val uuid: Uuid
     get() = id.uuid

   @Serializable
   data class WallboxSelectionId(val uuid: NativeUuid) {

     override fun toString(): String {
       return uuid.toString()
    }

    fun format(): String {
      return uuid.toString()
    }

    companion object {
      fun random(): WallboxSelectionId {
        return WallboxSelectionId(randomUuid4())
      }
    }
  }

}
